import { getFullUrl } from 'hubspot-url-utils';
import getTrainingAndServicesLink from '../../utils/getTrainingAndServicesLink';
import styled, { css } from 'foundations-theming/utils';
import { usePortal, useTranslation } from '../../hooks/useNavConfig';
import { MenuItem } from '../Menu';
import { isGlobalNavAcademyMode } from '../../utils/navEnviro';
import useHomePath from '../../hooks/useHomePath';
import ExternalLink from '../icons/ExternalLink';
import { ButtonWithDemoExitConfirmation } from '../DemoExitConfirmation/ButtonWithDemoExitConfirmation';
import { getTypographyStyles } from '../../nav-ui-components/Text';
import { withErrorBoundary } from '../ErrorBoundary';
import memoWithDisplayName from '../../utils/memoWithDisplayName';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const useExtraAccountItems = ({
  isDevPortal,
  hasProjectAccess,
  portalId,
  isAcademyMode,
  homePath
}) => {
  const {
    t
  } = useTranslation();
  return [isDevPortal ? {
    id: 'accountsAndBilling',
    link: `${getFullUrl('app')}/developer/${portalId}/account/`,
    linkText: t('nav.tools.devAccount')
  } : {
    id: 'accountsAndBilling',
    link: `${getFullUrl('app')}/account-dashboard/${portalId}/`,
    linkText: t('nav.tools.billing')
  }, isDevPortal ? null : isAcademyMode && homePath ? {
    id: 'academy',
    link: homePath,
    linkText: t('nav.account.hubspotSoftware')
  } : {
    id: 'academy',
    link: `${getFullUrl('app')}/academy/${portalId}?LC004=Control`,
    linkText: t('nav.tools.academy'),
    isExternal: true
  }, isDevPortal ? null : {
    id: 'productsAddons',
    link: `${getFullUrl('app')}/pricing/${portalId}?upgradeSource=nav-dropdown`,
    linkText: t('nav.tools.pricingAndFeatures'),
    isExternal: true
  }, {
    id: 'productUpdates',
    link: `${getFullUrl('app')}/product-updates/${portalId}`,
    linkText: t('nav.tools.productUpdates')
  }, hasProjectAccess ? {
    id: 'projects',
    link: `${getFullUrl('app')}/projects/${portalId}`,
    linkText: t('nav.tools.projects')
  } : null, {
    id: 'trainingAndServices',
    link: getTrainingAndServicesLink(),
    linkText: t('nav.tools.trainingAndServices'),
    isExternal: true
  }];
};
const StyledMenuItem = styled(MenuItem)(({
  theme,
  $index
}) => css(["list-style-type:none !important;a{margin:", ";padding:", " ", " !important;color:", " !important;display:block;", " text-decoration:none;&:hover,&:focus{text-decoration:underline !important;}svg{fill:", " !important;}}"], $index === 0 ? `${theme.space['250']} 0 0 !important` : '0 !important', theme.space['100'], theme.space['500'], theme.color['text-primary-default'], getTypographyStyles(theme, 'body-125'), theme.color['text-primary-default']));
const AccountExtraLink = ({
  id,
  link,
  linkText,
  index,
  isExternal
}) => {
  return /*#__PURE__*/_jsxs(ButtonWithDemoExitConfirmation, {
    component: StyledMenuItem,
    $index: index,
    id: id,
    href: link,
    target: isExternal ? '_blank' : undefined,
    children: [linkText, " ", isExternal && /*#__PURE__*/_jsx(ExternalLink, {})]
  });
};
const _AccountExtras = ({
  isDevPortal,
  hasProjectAccess
}) => {
  const isAcademyMode = isGlobalNavAcademyMode();
  const homePath = useHomePath();
  const {
    portalId
  } = usePortal();
  const accountItems = useExtraAccountItems({
    isDevPortal,
    hasProjectAccess,
    portalId,
    isAcademyMode,
    homePath
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: accountItems.map((accountItem, index) => {
      if (!accountItem || !accountItem.link || !accountItem.linkText) {
        return null;
      }
      return /*#__PURE__*/_createElement(AccountExtraLink, Object.assign({}, accountItem, {
        index: index,
        key: accountItem.id
      }));
    })
  });
};
export const AccountExtras = withErrorBoundary(memoWithDisplayName('AccountExtras', _AccountExtras), {
  boundaryName: 'AccountExtras'
});